import { useNavigate } from 'react-router-dom';
import React from 'react';
import { Button } from '@mui/material';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';

interface BackButtonProps {
    redirect?: string;
}

export const BackButton = ({ redirect }: BackButtonProps) => {
    let navigate = useNavigate();
    return (
        <Button
            startIcon={<ArrowBackIosNewOutlinedIcon />}
            onClick={() => (redirect ? navigate(redirect) : navigate(-1))}
            sx={{
                fontSize: 16,
                width: 100,
                marginTop: '10px',
            }}
        >
            Vissza
        </Button>
    );
};
